export enum DamageCause {
    Lynx = 1,
    Wolverine = 2,
    Bear = 3,
    Wolf = 4,
    Eagle = 5,
    UnknownProtected = 6,
}
